var toggleOverlayBox;

toggleOverlayBox = function($target) {
  var $body, $targetMediaHtml;
  $body = $('body');
  $target.toggleClass('overlayBox--open');
  $body.toggleClass('overlay-is-open');
  if (!$body.hasClass('overlay-is-open')) {
    if (($target.find('.mediaContainer').length)) {
      $targetMediaHtml = $target.find('.mediaContainer').html();
      return $target.find('.mediaContainer').html($targetMediaHtml);
    }
  }
};

$(function() {
  $('.js-video-toggle').on('click', function(e) {
    var $target, $this, target;
    e.preventDefault();
    $this = $(this);
    target = $this.attr('href');
    $target = $(target);
    return toggleOverlayBox($target);
  });
  return $('.overlayBox').on('click', function(e) {
    var $container, $target, $this;
    $this = $(this);
    $container = $this.find('.row, .overlayBox__close');
    if (!$container.is(e.target) && !$container.has(e.target).length) {
      $target = $this;
      return toggleOverlayBox($target);
    }
  });
});

// ---
// generated by coffee-script 1.9.2